export default __webpack_public_path__ + "static/media/ArialMT.be45eea7.ttf";